module.exports = __webpack_public_path__ + "static/media/epsBNB.7a44b8ea.png";